"use strict";

;
(function (ProductTooltips, $) {
  var addTooltips = function addTooltips() {
    $('.grid-product__swatch').tooltip({
      position: {
        my: 'center',
        at: 'center top+60',
        using: function using(position, feedback) {
          $(this).css(position);
          $('<div>').addClass('arrow').addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
        }
      }
    });
    $('.grid-product__swatch').each(function () {
      $(this).tooltip('option', 'classes.ui-tooltip', $(this).attr('data-tooltip'));
    });
  };
  var eventHandlers = function eventHandlers() {
    $(window).resize(function () {
      if (window.innerWidth >= 1024) {
        addTooltips();
      }
    });
  };
  ProductTooltips.init = function () {
    eventHandlers();
    if (window.innerWidth >= 1024) {
      addTooltips();
    }
  };
})(window.ProductTooltips = window.ProductTooltips || {}, jQuery, undefined);